import Axios from "initializers/axios"
import { ViewContext } from "concerns/useContextName"
import asyncDebounce from "helpers/asyncDebounce"
import { Mentionable } from "components/Wysiwyg/extensions/suus-mention/SuusMention"

export default function useMentionSearch(context: ViewContext = {}) {
  async function mentionableFunction({ query }): Promise<Mentionable[]> {
    const params = {
      group_id: context?.group?.id,
      client_id: context.client_id || context.client?.id,
      level_id: context.level_id || context.level?.id,
      query,
    }
    try {
      const { data } = await Axios.get("/mentionables.json", { params })
      return data
    } catch (err) {
      console.error(err)
      return []
    }
  }

  return {
    mentionableFunction: asyncDebounce(mentionableFunction, 500),
  }
}
